import { Component, inject } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { SimulationStepsBarComponent } from '@components/simulation-steps-bar/simulation-steps-bar.component';
import { SimulationSummaryComponent } from '@components/simulation-summary/simulation-summary.component';
import { SidePanelService } from '@services/side-panel.service';

@Component({
  imports: [ButtonComponent, SimulationStepsBarComponent, SimulationSummaryComponent],
  selector: 'app-simulation-page',
  styleUrl: './simulation.page.scss',
  templateUrl: './simulation.page.html',
})
export class SimulationPage {
  private readonly sidePanel = inject(SidePanelService);

  protected openParametersSummary(): void {
    this.sidePanel.open({
      component: SimulationSummaryComponent,
      id: 'simulation-summary',
      inputs: { variant: 'panel' },
      title: 'Resumen de simulación',
    });
  }
}
